import { useEffect, useRef } from 'react';
import {
  StatBoxBg1,
  StatBoxBg2,
  StatBoxBg3,
  StatBoxBg4
} from '../../constants/asset-constants';

const StatsSection = () => {
  const boxesRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('stat__box--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    boxesRef.current.forEach(box => {
      if (box) observer.observe(box);
    });

    return () => observer.disconnect();
  }, []);

  const setRef = index => el => {
    boxesRef.current[index] = el;
  };

  return (
    <div className='stats__section-container'>
      <div className='stats__boxes'>
        {[
          {
            extra: 'stat__box-one',
            content: (
              <p className='stat__box-text stat__box-one--text'>
                Trusted by Individuals & Businesses Worldwide
              </p>
            ),
            bg: StatBoxBg1
          },
          {
            content: (
              <>
                <p className='stat__box-text'>18K+</p>
                <p className='stat__box-text--two'>Nigerians trust us</p>
              </>
            ),
            bg: StatBoxBg2
          },
          {
            content: (
              <>
                <p className='stat__box-text'>150+</p>
                <p className='stat__box-text--two'>Countries Delivered</p>
              </>
            ),
            bg: StatBoxBg3
          },
          {
            content: (
              <>
                <p className='stat__box-text'>60%</p>
                <p className='stat__box-text--two'>
                  SME Exports to UK / USA / CA
                </p>
              </>
            ),
            bg: StatBoxBg4
          }
        ].map((box, i) => (
          <div
            key={i}
            ref={setRef(i)}
            className={`stat__box${box.extra ? ` ${box.extra}` : ''} stat__box--hidden`}
            style={{ '--delay': `${i * 120}ms` }}
          >
            {box.content}
            <img
              src={box.bg}
              alt='illustration'
              className='stat__box-bg--img'
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsSection;
